import { CaptureResult } from "@components/ChartCapture/types";

/** A data-bearing chart that failed to capture must block approval/signing. */
export const isDataBearingFailure = (result: CaptureResult): boolean =>
  result.timedOut || (result.hasData && !result.captured);
